import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import { changeStep } from 'store/modules';
import { StepContentWrapper } from 'components';
import { withWizard } from 'containers';

import { parseDataToApi } from 'utils/parseDataToApi';
import { blobToBase64 } from 'utils/pdfAcceptance';
import { AUTH_TYPES } from 'constants/authTypesName';

import {
  createSubscription,
} from 'services/api';

import { clearSubscription } from 'store/modules/subscription/actions';

import Contract from './contract';

export default function ContractWizard({
  navigateBack: parentNavigateBack,
  complete: parentNavigateForward,
  currentStep: parentCurrentStep,
}) {
  const theme = useContext(ThemeContext);
  const dispatch = useDispatch();
  const subscription = useSelector((state) => state.subscription);
  const { contract } = subscription.contractInfo || {};
  const {
    financeInfo, basicInfo, solutionInfo, paymentProfile,
  } = subscription;
  const { expirationDate, confirmation, payment } = financeInfo || {};

  const onValuesChanged = ({ values, currentStep }) => {
    if (values) {
      dispatch(
        changeStep({
          step: 'contractInfo',
          currentStep,
          parentCurrentStep,
          [values.childStep]: values.formValues[values.childStep],
        }),
      );
    }
  };

  function onSubmit({ navigateForward, childStep }) {
    return (values) => navigateForward({ childStep, formValues: values });
  }

  const onCompleted = () => {
    const managerName = basicInfo?.contactInfo?.managerName;
    const managerEmail = basicInfo?.contactInfo?.managerEmail;
    dispatch(clearSubscription());
    parentNavigateForward({ managerName, managerEmail });
  };

  const onFinalizeSubscription = async ({ pdfBlob, pdfSha256 } = {}) => {
    const validDiscountCoupon = confirmation.coupon || '';
    const vehicle_camera = solutionInfo?.cameraTypes?.conteleCamCount || 0;
    const vehicle_camera_ia = solutionInfo?.cameraTypes?.conteleCamIaCount || 0;
    const camera_setup = (vehicle_camera + vehicle_camera_ia) || 0;
    const isAllTrackers = solutionInfo?.trackersBatch?.isAllTrackers ?? true;
    const paymentMethod = payment?.paymentType;

    const subscriptionData = parseDataToApi({
      ...basicInfo,
      contele_system: solutionInfo?.vehicleManager?.conteleSystemCount || 0,
      contele_tracker: solutionInfo?.vehicleManager?.conteleTrackerCount || 0,
      plug_and_play: solutionInfo?.quantityTypes?.trackerPlugAndPlayCount || 0,
      tracker_2g: solutionInfo?.quantityTypes?.tracker2GCount || 0,
      tracker_4g: (solutionInfo?.quantityTypes?.tracker4GCount || 0) + (solutionInfo?.quantityTypes?.trackerPlugAndPlayCount || 0),
      blocking_12_volts: solutionInfo?.blocker?.useBlocker ? parseInt(solutionInfo?.blocker?.twelveVoltsCount) : 0,
      blocking_24_volts: solutionInfo?.blocker?.useBlocker ? parseInt(solutionInfo?.blocker?.twentyFourVoltsCount) : 0,
      fine_auto_update: solutionInfo?.finesManager?.fineManager || false,
      vehicle_camera,
      vehicle_camera_ia,
      discountCoupon: validDiscountCoupon,
      paymentMethod,
      camera_setup,
      expirationDate: expirationDate?.expirationDate,
      consultantId: basicInfo.gettingStarted?.seller_id,
      partial_shipment: !isAllTrackers,
      first_batch_quantity: isAllTrackers ? 0 : (solutionInfo?.trackersBatch?.trackersQuantity || 0),
      vindi_customer_id: paymentProfile?.vindi_customer_id,
      vindi_payment_profile_id: paymentProfile?.vindi_payment_profile_id,
    });

    if (pdfBlob && pdfSha256) {
      const pdfBase64 = await blobToBase64(pdfBlob);
      subscriptionData.contract_acceptance = {
        opt_in: true,
        pdf_sha256: pdfSha256,
        pdf_base64: pdfBase64,
      };
    }

    const tokenFromStorage = localStorage.getItem(AUTH_TYPES.STORAGE_AUTH_PARAM_NAME) || '';
    const authToken = JSON.parse(tokenFromStorage);

    await createSubscription({ subscriptionData, authToken });
  };

  const steps = [
    {
      content: (props) => (
        <Contract
          {...props}
          initialValues={contract}
          onCancel={parentNavigateBack}
          onFinalizeSubscription={onFinalizeSubscription}
          onSubmit={onSubmit({ ...props, childStep: 'contract' })}
        />
      ),
    },
  ];

  return withWizard({
    steps,
    theme,
    onValuesChanged,
    onCompleted,
  })(({ children }) => <StepContentWrapper>{children}</StepContentWrapper>);
}
